import app from './Vue/app';
import ImageCard from '@components/ImageCard.vue';
import DateTime from '@components/DateTime.vue';

app.component('DateTime', DateTime);
app.component('ImageCard', ImageCard);
